const theme = {
  colors: {
    main: {
      grey2: '#FAFAFA',
      grey5: '#F2F2F3',
      grey10: '#E4E5E7',
      grey20: '#C9CBCF',
      grey30: '#AFB2B6',
      grey40: '#94989E',
      grey50: '#797E86',
      grey60: '#61656B',
      grey70: '#494C50',
      grey80: '#303236',
      grey90: '#18191B',
      grey95: '#0C0D0D'
    },
    accent: {
      blue2: '#F5FBFF',
      blue5: '#E6F4FF',
      blue10: '#CCEAFF',
      blue20: '#99D5FF',
      blue30: '#66BFFF',
      blue40: '#33AAFF',
      blue50: '#0095FF',
      blue60: '#0077CC',
      blue70: '#005999',
      blue80: '#003C66',
      blue90: '#001E33',
      blue95: '#000F1A'
    },
    error: {
      red2: '#FFF6F5',
      red5: '#FFEAE6',
      red10: '#FED5CD',
      red20: '#FEAB9A',
      red30: '#FD8168',
      red40: '#FD5635',
      red50: '#FC2C03',
      red60: '#CA2302',
      red70: '#971B02',
      red80: '#651201',
      red90: '#320901',
      red95: '#190400'
    },
    success: {
      green2: '#F7FDF8',
      green5: '#EBFAEE',
      green10: '#D6F5DE',
      green20: '#AEEABD',
      green30: '#85E09C',
      green40: '#5DD57B',
      green50: '#34CB5A',
      green60: '#2AA248',
      green70: '#1F7A36',
      green80: '#155124',
      green90: '#0A2912',
      green95: '#051409'
    },
    other: {
      white: '#FFFFFF',
      black: '#000000',
      blueButton: '#0080e0',
      purple50: '#9747FF'
    },
    deco: {
      gradientlight: 'linear-gradient(90deg, rgba(153, 213, 255, 1) 0%, rgba(0, 149, 255, 1) 100%)',
      gradientmedium: 'linear-gradient(90deg, rgba(0, 149, 255, 1) 0%, rgba(0, 60, 102, 1) 100%)',
      gradientblack: 'linear-gradient(90deg, rgba(48, 50, 54, 1) 0%, rgba(12, 13, 13, 1) 100%)'
    }
  },
  fonts: {
    sectionTitle: {
      fontFamily: 'Montserrat SemiBold',
      fontSize: '28px',
      lineHeight: '39px',
      fontWeight: 600,
      fontStyle: 'normal'
    },
    smallTitleRegular: {
      fontFamily: 'Montserrat Regular',
      fontSize: '21px',
      lineHeight: '28px',
      fontWeight: 400,
      fontStyle: 'normal'
    },
    smallTitleSemiBold: {
      fontFamily: 'Montserrat SemiBold',
      fontSize: '21px',
      lineHeight: '28px',
      fontWeight: 600,
      fontStyle: 'normal'
    },
    highlightMedium: {
      fontFamily: 'Montserrat Medium',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 500,
      fontStyle: 'normal'
    },
    highlightBold: {
      fontFamily: 'Montserrat Bold',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 700,
      fontStyle: 'normal'
    },
    bodyTextRegular: {
      fontFamily: 'Montserrat Regular',
      fontSize: '14px',
      lineHeight: '19px',
      fontWeight: 400,
      fontStyle: 'normal'
    },
    bodyTextMedium: {
      fontFamily: 'Montserrat Medium',
      fontSize: '14px',
      lineHeight: '19px',
      fontWeight: 500,
      fontStyle: 'normal'
    },
    bodyTextSemiBold: {
      fontFamily: 'Montserrat SemiBold',
      fontSize: '14px',
      lineHeight: '19px',
      fontWeight: 600,
      fontStyle: 'normal'
    },
    bodyTextBold: {
      fontFamily: 'Montserrat Bold',
      fontSize: '14px',
      lineHeight: '19px',
      fontWeight: 700,
      fontStyle: 'normal'
    },
    footnoteLight: {
      fontFamily: 'Montserrat Light',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 300,
      fontStyle: 'normal'
    },
    footnoteRegular: {
      fontFamily: 'Montserrat Regular',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 400,
      fontStyle: 'normal'
    },
    footnoteMedium: {
      fontFamily: 'Montserrat Medium',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 500,
      fontStyle: 'normal'
    },
    footnoteSemiBold: {
      fontFamily: 'Montserrat SemiBold',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 600,
      fontStyle: 'normal'
    },
    bold: {
      fontFamily: 'Montserrat Bold'
    },
    semiBold: {
      fontFamily: 'Montserrat SemiBold'
    },
    medium: {
      fontFamily: 'Montserrat Medium'
    },
    regular: {
      fontFamily: 'Montserrat Regular'
    },
    light: {
      fontFamily: 'Montserrat Light'
    }
  },
  styles: {
    selectWithInput: (hasError = false, customStyles = {}) => {
      return {
        control: (provided, state) => {
          const defaultStyles = {
            ...provided,
            borderRadius: 8,
            borderStyle: null,
            boxShadow: 'none !important',
            border: state.isDisabled
              ? 'none'
              : hasError
                ? '2px solid var(--red-50, #FC2C03) !important'
                : '1px solid var(--grey-20, #C9CBCF) !important',
            bordeRadius: '8px !important',
            minHeight: '35px',
            width: '100%',
            minWidth: '200px',
            fontFamily: 'Montserrat Regular !important',

            '&:hover': {
              background: 'var(--grey-5, #F2F2F3) !important',
              border: state.isDisabled
                ? 'none'
                : hasError
                  ? '2px solid var(--red-50, #FC2C03) !important'
                  : '1px solid var(--grey-20, #C9CBCF) !important'
            }
          };

          // Handle customStyles.customControl: if function, call it; if object, spread it
          if (customStyles?.customControl) {
            if (typeof customStyles.customControl === 'function') {
              return customStyles.customControl(defaultStyles, state);
            } else if (typeof customStyles.customControl === 'object' && !Array.isArray(customStyles.customControl)) {
              return {
                ...defaultStyles,
                ...customStyles.customControl
              };
            }
          }

          return defaultStyles;
        },
        valueContainer: (provided, state) => ({
          ...provided,
          marginTop: '-2px',
          overflow: 'visible',
          padding: state.isMulti && state.hasValue ? '0!important' : '0px 16px!important'

          // height: '35px',
        }),
        placeholder: (provided) => ({
          ...provided,
          color: 'var(--grey-30, #AFB2B6) !important',
          padding: '0px !important',
          fontFamily: 'Montserrat Regular !important',
          opacity: 0.6,
          ...customStyles?.placeholder
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 99,
          borderRadius: 8,
          padding: 0,
          scrollbarGutter: 'stable',
          ...(customStyles?.menu || {})
        }),
        menuList: (provided) => ({
          ...provided,
          padding: 0,
          borderRadius: 8,
          zIndex: 99,
          maxHeight: '150px',
          overflowY: 'scroll',
          scrollbarWidth: 'thin',
          '&::-webkit-scrollbar': {
            width: '8px'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            borderRadius: '4px',
            border: 'none'
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.3)'
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
          },
          '&::-webkit-scrollbar-track:hover': {
            backgroundColor: 'transparent'
          },
          ...(customStyles?.menuList || {})
        }),
        option: (provided, state) => {
          const { data, selectProps } = state;
          const options = selectProps.options;
          const isFirstOption = options[0].value === data.value;
          const isLastOption = options[options.length - 1].value === data.value;

          return {
            ...provided,
            borderRadius: isFirstOption ? '8px 8px 0 0' : isLastOption ? '0 0 8px 8px' : '0',
            backgroundColor: state.isSelected
              ? 'var(--blue-50)'
              : state.isFocused
                ? 'var(--blue-5)'
                : '#FFFFFF',
            color: state.isSelected ? 'var(--white)' : 'var(--grey-95)',
            textAlign: 'left',
            fontFamily: 'Montserrat Regular !important',
            ...(customStyles?.option || {})
          };
        },
        input: (provided) => ({
          ...provided,
          padding: '0px !important',
          // border: 'none !important',
          background: 'transparent !important',

          '& input, & input:focus': {
            // border: 'none !important',
            background: 'transparent !important'
          }
        }),
        singleValue: (provided, state) => ({
          ...provided,
          color: state.isDisabled ? 'var(--grey-20, #C9CBCF)' : 'var(--grey-95, #0C0D0D)',
          maxWidth: 'calc(100% - 12px)',
          span: {
            color: state.isDisabled ? 'var(--grey-20, #C9CBCF)' : 'var(--grey-95, #0C0D0D)'
          }
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          marginTop: '-2px',
          color: 'var(--grey-20, #C9CBCF) !important',
          height: '35px'
        }),
        indicatorSeparator: (provided) => ({
          ...provided,
          display: 'none'
        }),
        indicatorsContainer: (provided) => ({
          ...provided,
          marginTop: '-2px',
          color: 'var(--grey-20, #C9CBCF) !important'
        }),
        clearIndicator: (provided) => ({
          ...provided,
          color: 'var(--grey-20, #C9CBCF) !important'
        }),
        menuPortal: (provided) => ({
          ...provided,
          zIndex: 10000000,
          ...(customStyles?.menuPortal || {})
        }),
        multiValue: (base) => ({
          ...base,
          backgroundColor: 'var(--grey-10)',
          borderRadius: '4px',
          color: 'var(--grey-95)',
          fontSize: '14px',
          fontFamily: 'Montserrat Regular',
          margin: '4px 8px 4px 4px !important',
          span: {
            color: 'var(--grey-95) '
          }
        })
      };
    }
  }
};

const jyskTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    main: {
      ...theme.colors.main,
      grey95: '#4D4D4D'
    },
    accent: {
      ...theme.colors.accent,
      blue50: '#143C8A',
      blue95: '#102E4C'
    }
  }
};

export { jyskTheme, theme };
